/**
 * 348 (#952): the name a customer types must match their IC, or identity checks and bookings stall. One sentence, shown
 * next to the name fields on sign-up and on the profile, and read by screen readers with those fields.
 */
export const NAME_IC_HINT =
  'Enter your full name exactly as it appears on your IC (MyKad) or passport.';
export const NAME_IC_HINT_ID = 'name-ic-hint';
